/**
 * Horizontal inset around the stacked **alert band** in ``WorkbenchPromptCard`` (Claude-style rear card).
 */
export const WORKBENCH_PROMPT_ALERT_BAND_OUTER_PADDING = 'px-3 md:px-2';

/**
 * Agentic Activities stream — aligns with **where ``rounded-t-xl`` meets the flat top** on the rear
 * alert chrome in ``WorkbenchPromptCard``: ``WORKBENCH_PROMPT_ALERT_BAND_OUTER_PADDING`` + xl radius (`0.75rem`),
 * matching Tailwind defaults for ``rounded-t-xl`` / ``spacing.3`` / ``spacing.2`` → ``px-6 md:px-5``.
 */
export const WORKBENCH_ACTIVITIES_STREAM_OUTER_PADDING = 'px-6 md:px-5';

export const WORKBENCH_PROMPT_INNER_WRAPPER = 'relative w-full rounded-md';

const BASE =
  // NO min-height inflation: the field is its NATURAL one-line height (~20px for
  // text-sm/leading-snug). The row (`flex items-center`) then centers this small
  // field against the h-7 buttons — true vertical centering. Inflating min-h to
  // 28px pinned the ~20px text to the TOP of an oversized box ("aligned upward").
  'relative z-10 block w-full max-h-[200px] overflow-y-auto p-0 m-0 border-0 ' +
  'text-sm leading-snug ' +
  // whitespace-pre-wrap: the contenteditable Build composer collapses newlines
  // without this — so innerText read the prompt as ONE line (the "merged to one
  // sentence" bug) BEFORE BuildTab could preserve it. With pre-wrap the DOM keeps
  // line breaks, so innerText returns them. (Harmless for the room <textarea>,
  // which preserves natively.)
  'whitespace-pre-wrap break-words ' +
  'rounded-md align-middle ' +
  'outline-none focus:outline-none focus-visible:outline-none ' +
  'ring-0 focus:ring-0 focus-visible:ring-0 ' +
  '[-webkit-tap-highlight-color:transparent] ' +
  'resize-none';

const DISABLED = 'cursor-not-allowed opacity-50 text-gray-500';
const ENABLED = 'text-gray-900';

/** @param {object} p @param {boolean} p.disabled */
export function getWorkbenchPromptInputClassName({ disabled } = { disabled: false }) {
  return `${BASE} ${disabled ? DISABLED : ENABLED}`.replace(/\s+/g, ' ').trim();
}

/** Inline styles both fields use; auto-resize hook then overwrites `height` */
export const WORKBENCH_PROMPT_FIELD_STYLE = {
  maxHeight: '200px',
  resize: 'none',
};
